import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 10000, suffix: "+", label: "Happy Travellers" },
  { value: 500, suffix: "+", label: "Visa Approvals" },
  { value: 25, suffix: "+", label: "Countries" },
  { value: 5, suffix: "★", label: "Customer Rating", decimals: 1 },
  { value: 24, suffix: "×7", label: "Travel Assistance" },
];

function Counter({ value, suffix, decimals = 0, inView }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const duration = 1800;
    const start = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      setN(value * ease(t));
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  const display = decimals ? n.toFixed(decimals) : Math.round(n).toLocaleString();
  return (
    <span className="font-display text-4xl md:text-5xl text-[#0A2342]">
      {display}
      <span className="text-[#C9A227]">{suffix}</span>
    </span>
  );
}

export default function TrustCounters() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section ref={ref} className="relative z-20 -mt-20 px-4 md:px-8" data-testid="trust-counters">
      <div className="max-w-6xl mx-auto glass rounded-3xl px-6 md:px-12 py-10 md:py-12 shadow-[0_30px_80px_-30px_rgba(10,35,66,0.25)]">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-8 gap-x-4 text-center">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} inView={inView} />
              <div className="mt-2 text-xs md:text-sm uppercase tracking-[0.18em] text-[#6B7280]">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
